import { useLoadDetails } from 'pages/custom/shared/CustomMapPage/useLoadDetails';
import { useLoadMap } from 'pages/custom/shared/CustomMapPage/useLoadMap';
import { useLoadMarkers } from 'pages/custom/shared/CustomMapPage/useLoadMarkers';

export const useCustomMapPage = (mapId: string, opts: { skip: boolean }) => {
    useLoadMap(mapId, opts);
    useLoadMarkers(mapId);
    useLoadDetails(mapId, opts);
};
